export enum AssetStatus {
  Draft,
  Active,
  Inactive,
  Sold
}

export enum AssetStatusLabels {
  Draft = 'Draft',
  Active = 'Active',
  Inactive = 'Inactive',
  Sold = 'Sold'
}
